export const home = {
  title: 'Best available technologies and measures to reduce environmental impacts',
  headerDescription:
    "At Inditex we are committed to radically reduce the potential environmental impacts of our activity. We truly believe we should collaborate all together to transform the future of our industry. That's why we have worked along with experts to develop this tool to support wet processes' manufacturers (dyeing, printing, laundry, and leather-related activities).",
  headerButton: 'Discover',
  techMeasuresTab: 'Tech & Measures',
  renewableEnergyTab: 'Renewable Energy',
  techMeasureDetail: 'Tech Measure Detail',
  footerText: 'Need some help or want to share your feedback?',
  manufacturingProcessSelection: 'Manufacturing Process Selection',
  manufacturingProcessTitle: 'What manufacturing process define your expertise?',
  contactUs: 'Contact us'
};
